import {UnknownStructuredTable} from '../StructuredTableConstants';

export function hasAnyFinalizedRows(
  structuredTable: UnknownStructuredTable,
  start?: number,
  end?: number
): boolean {
  const startIndex = start ?? 0;
  const endIndex = end ?? structuredTable.rows.length - 1;
  return structuredTable.rows.slice(startIndex, endIndex + 1).some((row) => row?.isFinalized);
}

export function hasAnyFinalizedRowsInRanges(
  structuredTable: UnknownStructuredTable,
  ranges: Array<[number, number]>
): boolean {
  return ranges.some(([start, end]) => hasAnyFinalizedRows(structuredTable, start, end));
}
